<template>
  <v-container>
    <v-dialog
      v-model="showIntroModal"
      width="600"
      persistent>
      <v-card class="pa-6 modal-container">
        <div class="_fs-24">
          บริการนำส่งภาษีหัก ณ ที่จ่าย
        </div>
        <div>
          <div class="_fs-16">
            จัดการภาษีง่ายขึ้น ให้ Sellsuki ดูแลแทนคุณ คุณสามารถมอบอำนาจให้ Sellsuki เป็นตัวแทนหักและนำส่งภาษี ณ ที่จ่าย เพื่อลดความยุ่งยากและป้องกันความผิด พลาดในการส่งภาษี
          </div>
          <br>
          <div class="_fs-16">
            ขั้นตอนการดำเนินการ ยื่นเอกสารออนไลน์ หน้า "จัดการภาษี" ได้ทันทีตั้งแต่วันนี้
          </div>
          <div class="_fs-16">
            รอผลอนุมัติ: ระบบจะแจ้งผลทางอีเมลภายใน 3-5 วันทำการ
          </div>
          <v-checkbox
            v-model="introAccepted"
            label="ไม่แสดงข้อความนี้อีก"
            hide-details
          ></v-checkbox>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            rounded
            class="py-2 px-16"
            @click="confirmIntroModal"
          >
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12">
        <div class="tax-agent-content">
          <div class="tax-agent-header">
            <div class="_fs-36">
              บริการนำส่งภาษีหัก ณ ที่จ่าย
            </div>
            <div>
              แต่งตั้งให้ Sellsuki เป็นตัวแทนหักและนำส่งภาษี ณ ที่จ่าย
            </div>
            <v-divider></v-divider>
          </div>
          <div class="tax-agent-detail">
            <div>
              ดาวน์โหลดแบบฟอร์มหนังสือแต่งตั้ง บริษัท เซลสุกิ เป็นตัวแทนหักภาษี ณ ที่จ่าย
              <a
                href="#"
                @click.prevent="handlePreviewTaxAgent"
              >ที่นี่</a>
            </div>
            <div>
              ดาวน์โหลดตัวอย่างการกรอกข้อมูลในหนังสือแต่งตั้งและขั้นตอนการซื้ออากรแสตมป์อิเล็กทรอนิกส์
              (e-Stamp)
              <a
                href="#"
                @click.prevent="handleDownloadExample"
              >ที่นี่</a>
            </div>
          </div>
        </div>
        <div class="tax-agent-footer">
          <v-progress-circular
            v-if="loading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-card
            v-else-if="showExistingTaxAgent"
            outlined
            class="tax-agent-card"
          >
            <v-row
              no-gutters
            >
              <v-col
                cols="12"
                sm="3"
                class="pr-6"
              >
                <div class="grey--text text--darken-1 caption">
                  เลขประจำตัวผู้เสียภาษี
                </div>
                <div class="primary--text">
                  {{ taxAgent.company && taxAgent.company.tax_id }}
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                class="pr-6"
              >
                <div class="grey--text text--darken-1 caption">
                  ชื่อบริษัท
                </div>
                <div>{{ taxAgent.company && taxAgent.company.name }}</div>
              </v-col>
              <v-col
                cols="12"
                sm="3"
                class="pr-6"
              >
                <div class="grey--text text--darken-1 caption">
                  วันที่และเวลาส่งเอกสาร
                </div>
                <div>{{ taxAgentCreateAt | dateTimeFormat('DD MMM YYYY - HH:mm') }}</div>
              </v-col>
              <v-col
                cols="3"
                sm="2"
                class="text-sm-right"
              >
                <div
                  class="grey--text text--darken-1 caption"
                  style="visibility: hidden"
                >
                  สถานะ
                </div>
                <span
                  class="existing-tax-agent-status"
                  :class="taxAgentStatusClass"
                >
                  <span class="status-dot"></span>
                  {{ taxAgentStatusText }}
                </span>
              </v-col>
            </v-row>

            <template v-if="taxAgent.status === TaxAgentStatus.Rejected && showDocumentResult">
              <div
                v-if="approvedDocuments.length || companyStatus === TaxAgentStatus.Approved"
                class="tax-agent-result-section"
              >
                <div class="tax-agent-result-title">
                  รายการที่ผ่านการอนุมัติ
                </div>
                <div class="tax-agent-result-list">
                  <div
                    v-if="companyStatus === TaxAgentStatus.Approved"
                    class="tax-agent-result-list-approved-item"
                  >
                    <v-icon
                      color="success"
                      size="20"
                    >
                      mdi-check-circle-outline
                    </v-icon>
                    <span>{{ documentLabel('companyInfo') }}</span>
                  </div>
                  <div
                    v-for="(doc, idx) in approvedDocuments"
                    :key="`approved-${idx}`"
                    class="tax-agent-result-list-approved-item"
                  >
                    <v-icon
                      color="success"
                      size="20"
                    >
                      mdi-check-circle-outline
                    </v-icon>
                    <span>{{ documentLabel(doc.document_type) }}</span>
                  </div>
                </div>
              </div>

              <div
                v-if="rejectedDocuments.length || companyStatus === TaxAgentStatus.Rejected"
                class="tax-agent-result-section"
              >
                <div class="tax-agent-result-title">
                  รายการที่ไม่ผ่านการอนุมัติ
                </div>
                <div class="tax-agent-result-list">
                  <div
                    v-if="companyStatus === TaxAgentStatus.Rejected"
                    class="tax-agent-result-list-rejected-item"
                  >
                    <v-icon
                      color="error"
                      size="20"
                    >
                      mdi-close-circle-outline
                    </v-icon>
                    <div class="tax-agent-result-list__rejected">
                      <div>{{ documentLabel('companyInfo') }}</div>
                      <div
                        v-if="taxAgent.company.remark"
                        class="rejection-reason"
                      >
                        เหตุผล: {{ taxAgent.company.remark }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-for="(doc, idx) in rejectedDocuments"
                    :key="`rejected-${idx}`"
                    class="tax-agent-result-list-rejected-item"
                  >
                    <v-icon
                      color="error"
                      size="20"
                    >
                      mdi-close-circle-outline
                    </v-icon>
                    <div class="tax-agent-result-list__rejected">
                      <div>{{ documentLabel(doc.document_type) }}</div>
                      <div
                        v-if="doc.remark"
                        class="rejection-reason"
                      >
                        เหตุผล: {{ doc.remark }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="taxAgent.status === TaxAgentStatus.Rejected"
                class="tax-agent-result-actions"
              >
                <v-btn
                  color="primary"
                  rounded
                  class="py-2 px-16"
                  @click="$router.push({ name: 'TaxAgentEdit' })"
                >
                  แก้ไขรายการ
                </v-btn>
              </div>
            </template>
          </v-card>
          <v-btn
            v-else
            color="primary"
            rounded
            class="button py-2 px-6"
            @click="$router.push({ name: 'TaxAgentCreate' })"
          >
            เริ่มการยื่นเอกสาร
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import dayjs from 'dayjs'
import { createDayjsDate } from '@/utils/dayjs'
import { mapState, mapGetters, mapActions } from 'vuex'
import renderTemplate from '@/libs/paper-template/template-handler.js'
import { TaxAgentStatus } from '@/utils/defaultValue'

const TAX_AGENT_INTRO_KEY = 'taxAgentIntroDismissed'

const STATUS_CONFIG = {
  [TaxAgentStatus.Pending]: { text: 'กำลังดำเนินการ', cssClass: 'status--pending' },
  [TaxAgentStatus.Approved]: { text: 'อนุมัติแล้ว', cssClass: 'status--approved' },
  [TaxAgentStatus.Rejected]: { text: 'รายการถูกตีกลับ', cssClass: 'status--rejected' }
}

const DOCUMENT_LABELS = {
  companyInfo: 'ข้อมูลร้านค้า หรือบริษัท',
  companyCertificate: 'หนังสือรับรองบริษัท',
  idCardCopy: 'สำเนาบัตรประจำตัวประชาชนผู้มอบอำนาจ',
  taxAgent: 'เอกสารการแต่งตั้ง บริษัท เซลสุกิ จำกัด',
  other: 'อื่นๆ'
}

export default {
  name: 'TaxAgent',
  data() {
    return {
      TaxAgentStatus,
      showIntroModal: false,
      introAccepted: false,
      showExistingTaxAgent: false,
      loading: false
    }
  },
  computed: {
    ...mapState('TaxAgent', ['taxAgent']),
    ...mapState('User', ['userProfile']),
    ...mapGetters({
      activeLineOfficialAccount: 'User/activeLineOfficialAccount'
    }),
    taxAgentStatusText() {
      return (STATUS_CONFIG[this.taxAgent.status] || STATUS_CONFIG.pending).text
    },
    taxAgentStatusClass() {
      return (STATUS_CONFIG[this.taxAgent.status] || STATUS_CONFIG.pending).cssClass
    },
    taxAgentCreateAt() {
      const { created_at } = this.taxAgent
      return created_at ? createDayjsDate(dayjs.utc(created_at)) : created_at
    },
    taxAgentDocuments() {
      return this.taxAgent.tax_agent_document || this.taxAgent.taxAgentDocument || []
    },
    approvedDocuments() {
      return this.taxAgentDocuments.filter((d) => d.status === TaxAgentStatus.Approved)
    },
    rejectedDocuments() {
      return this.taxAgentDocuments.filter((d) => d.status === TaxAgentStatus.Rejected)
    },
    showDocumentResult() {
      const hasDocResult = this.approvedDocuments.length > 0 || this.rejectedDocuments.length > 0
      const hasCompanyResult = this.companyStatus !== TaxAgentStatus.Pending
      return this.taxAgent.status !== TaxAgentStatus.Pending
    && (hasDocResult || hasCompanyResult)
    },
    companyStatus() {
      return this.taxAgent?.company?.tax_agent_status || TaxAgentStatus.Pending
    }
  },
  async created() {
    if (!localStorage.getItem(TAX_AGENT_INTRO_KEY)) {
      this.showIntroModal = true
    }
    const citizenId = this.activeLineOfficialAccount && this.activeLineOfficialAccount.citizenId
    this.loading = true
    try {
      await this.getTaxAgentByTaxId(citizenId)
      if (this.taxAgent.id) {
        this.showExistingTaxAgent = true
      }
    } catch (_e) {
      // no existing tax agent — do nothing
    } finally {
      this.loading = false
    }
  },
  methods: {
    ...mapActions({
      getTaxAgentByTaxId: 'TaxAgent/getTaxAgentByTaxId'
    }),
    documentLabel(type) {
      return DOCUMENT_LABELS[type] || type
    },
    async handlePreviewTaxAgent() {
      const formatThaiDate = (isoString) => {
        const d = new Date(isoString)
        const thaiMonths = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม']
        const day = String(d.getUTCDate()).padStart(2, '0')
        const month = thaiMonths[d.getUTCMonth()]
        const year = d.getUTCFullYear()
        return `${day}/${month}/${year}`
      }
      const date = new Date().toISOString()
      const userProfile = this.userProfile.activeLineOfficialAccount
      const data = {
        headerDate: formatThaiDate(date),
        createdAt: date,
        company: userProfile.companyName,
        address: `${userProfile.address || '-'} ถนน${userProfile.street || '-'} แขวง${userProfile.subdistrict || '-'} เขต${userProfile.district} ${userProfile.stateProvince} ${userProfile.zipCode}`,
        citizenId: userProfile.citizenId
      }
      await renderTemplate(data)
    },
    async handleDownloadExample() {
      const response = await fetch('/tax-agent-example.pdf')
      const blob = await response.blob()
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'ตัวอย่าง หนังสือแต่งตั้งตัวแทนหักภาษี ณ ที่จ่ายและมอบอํานาจให้กระทําการแทน.pdf'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    confirmIntroModal() {
      if (this.introAccepted === true) {
        localStorage.setItem(TAX_AGENT_INTRO_KEY, 'true')
      }
      this.showIntroModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
.tax-agent-content {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .tax-agent-header {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .tax-agent-detail {
    padding: 24px;
    background-color: #F4F4F4;
    color: #0A0A0A
  }
}

.modal-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.v-card__actions {
  .spacer {
    display: none;
  }
  justify-content: center;
}

.tax-agent-footer {
  display: flex ;
  justify-content: center;

  .tax-agent-card {
    width: 100%;
    margin-top: 40px;
    padding: 25px;
  }

  .button {
    margin-top: 56px;
    align-content: center;
    justify-content: center;
  }
}

.tax-agent-result-section {
  margin-top: 16px;
  padding: 16px 20px;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
}

.tax-agent-result-title {
  font-weight: 500;
  margin-bottom: 8px;
}

.tax-agent-result-list {
  list-style: none;
  padding-left: 0;
  margin: 0;

  .tax-agent-result-list-approved-item {
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0;
  }

  .tax-agent-result-list-rejected-item {
    font-size: 14px;
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 0;

    &:not(:last-child) {
      margin-bottom: 8px;
    }
  }
}

.tax-agent-result-list__rejected {
  display: flex;
  flex-direction: column;
  width: 100%;

  .rejection-reason {
    color: #757575;
    font-size: 14px;
    margin-top: 2px;
    overflow-wrap: break-word;
    word-break: break-word;
    width: 100%;
  }
}

.tax-agent-result-actions {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.existing-tax-agent-status {
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  gap: 6px;

  .status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    background-color: currentColor;
  }

  &.status--pending {
    color: #E07B25;
  }

  &.status--approved {
    color: #4CAF50;
  }

  &.status--rejected {
    color: #F44336;
  }
}

  a {
    color: #1B8BF5;
  }

</style>
